export const ANALYTICS_CATEGORY = 'share-report';
